import script from "./ProjectStats.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectStats.vue?vue&type=script&setup=true&lang=js"

import "./ProjectStats.vue?vue&type=style&index=0&id=24b2e505&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b2e505"]])

export default __exports__